import { downloadReportApi } from "services/dashboard";
import { downloadFile } from "utils/commonFun";
import { failMessage } from "utils/toastMessage";

export const getDownloadReport = async (selectedSite = {}, setLoading = () => { }, customDate = {}, selectedDay = '') => {
    if (selectedSite?._id) {
        try {
            setLoading(true)
            const res = await downloadReportApi({
                plantId: selectedSite?._id,
                ...(customDate.from && customDate.to
                    ? {
                        range: 'custom',
                        from: customDate.from,
                        to: customDate.to,
                    }
                    : {
                        range: selectedDay,
                    }),
            });
            if (res?.status === 200) {
                downloadFile(res?.data?.url)
            } else {
                failMessage(res)
            }
        } catch (e) {
            console.log('error', e?.message)
        } finally {
            setLoading(false)
        }
    }
}